import { Component, ChangeDetectionStrategy } from '@angular/core';

import { TranslocoModule } from '@jsverse/transloco';
import { PipesModule } from '@cbcore/pipes/pipes.module';
import { Config } from "@cbcore/services/config/config.service";
import { CalculationsService } from "@cbcore/services/utils/calculations/calculations.service";
import { RacingUnitsDistributionBase } from '../base/racing-units-distribution.base';

@Component({
    selector: 'ud-golf',
    templateUrl: './default/golf/golf.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslocoModule, PipesModule]
})
export class GolfComponent extends RacingUnitsDistributionBase {
  constructor(
    protected override _config: Config,
    protected override _calculationsService: CalculationsService
  ) {
    super(_config, _calculationsService);
  }

  protected override initializeUrls(): void {
    this.silksUrl = this._config.CONFIG.silksUrl;
    this.bucket = this._config.CONFIG.silkBucket;
  }

  // Used for GOLF_WINNER, GOLF_PLACE
  override getUnits(distribution: any): number {
    return super.getUnits(distribution);
  }
}